export const ONBOARDING_SHEET_CLOSE_MS = 380;
export const ONBOARDING_SHEET_EXIT_EVENT = "onboarding-sheet-exit";

export function triggerOnboardingSheetExit() {
  window.dispatchEvent(new CustomEvent(ONBOARDING_SHEET_EXIT_EVENT));
}
